// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_List from "../Specular.FRP.List/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var Item = function (x) {
    return x;
};
var Mapping = function (x) {
    return x;
};
var subform = function (v) {
    return v.subform;
};
var queryMapMapping = function (dictOrd) {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                return function (v) {
                    return Restaumatic_Form.annotatedFinal("query Mapping")(Restaumatic_Form_Final.makeFinalV(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })())(Data_Symbol.SProxy.value)(v)))(function (items) {
                        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "keys";
                            }
                        })())(Data_Symbol.SProxy.value)(v))))(function (keys_) {
                            var entryResults = Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray)(keys_)(function (k) {
                                var v1 = Data_Map_Internal.lookup(dictOrd)(k)(items);
                                if (v1 instanceof Data_Maybe.Just) {
                                    return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v2) {
                                        return function (v3) {
                                            var handleInvalid = (function () {
                                                var $97 = Data_Eq.eq(Restaumatic_Form.eqStrictness)(strictness)(Restaumatic_Form.Lax.value);
                                                if ($97) {
                                                    return Data_Validation_Semigroup.validation(function (v4) {
                                                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(Data_Maybe.Nothing.value);
                                                    })(Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString))))));
                                                };
                                                return Control_Category.identity(Control_Category.categoryFn);
                                            })();
                                            var v4 = Data_Newtype.unwrap()(v2);
                                            if (v4 instanceof Data_Either.Right && !v4.value0) {
                                                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(Data_Maybe.Nothing.value);
                                            };
                                            return handleInvalid(Control_Apply.apply(Data_Validation_Semigroup.applyV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(Data_Functor.map(Data_Validation_Semigroup.functorV)(function (v5) {
                                                return function (v6) {
                                                    return new Data_Maybe.Just(new Data_Tuple.Tuple(k, v5));
                                                };
                                            })(v3))(v2));
                                        };
                                    })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "presentWhen";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v1.value0)))(Restaumatic_Form_Final.unFinalV)))(Restaumatic_Form_Final.unFinalV(Restaumatic_Form.queryWith(dictQuery)(strictness)(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "subform";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v1.value0))));
                                };
                                if (v1 instanceof Data_Maybe.Nothing) {
                                    return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.internalError("Mapping key not found")));
                                };
                                throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 179, column 9 - line 199, column 77): " + [ v1.constructor.name ]);
                            });
                            return Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                                var $144 = Data_Functor.map(Data_Validation_Semigroup.functorV)((function () {
                                    var $147 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                                    return function ($148) {
                                        return $147(Data_Array.catMaybes($148));
                                    };
                                })());
                                var $145 = Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))));
                                return function ($146) {
                                    return $144($145($146));
                                };
                            })())(entryResults);
                        });
                    })));
                };
            }
        };
    };
};
var querySerializedMapMapping = function (dictOrd) {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                var $149 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Map_Serialized.SerializedMap);
                var $150 = Restaumatic_Form.queryWith(queryMapMapping(dictOrd)(dictQuery))(strictness);
                return function ($151) {
                    return $149($150($151));
                };
            }
        };
    };
};
var queryItem = function (dictQuery) {
    return {
        queryWith: function (s) {
            return function (v) {
                return Restaumatic_Form.queryWith(dictQuery)(s)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "subform";
                    }
                })())(Data_Symbol.SProxy.value)(v));
            };
        }
    };
};
var presentWhen = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "presentWhen";
            }
        })())(Data_Symbol.SProxy.value)(v1))(v));
    };
};
var newtypeMapping = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeItem = {
    Coercible0: function () {
        return undefined;
    }
};
var mergeItem = function (dictMerge) {
    return {
        merge: function (x) {
            return function (v) {
                return Restaumatic_Form.merge(dictMerge)(x)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "subform";
                    }
                })())(Data_Symbol.SProxy.value)(v));
            };
        }
    };
};
var makeItem = function (dictShow) {
    return function (dictMakeEmpty) {
        return function (dictAddContext) {
            return function (v) {
                return function (key1) {
                    return function __do() {
                        var subform1 = Restaumatic_Form.makeEmptyImpl(dictMakeEmpty)({
                            name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "name";
                                }
                            })())(Data_Symbol.SProxy.value)(v))([ Data_Show.show(dictShow)(key1) ])
                        })();
                        var presentWhen1 = Specular_Ref.newRef(Effect_Class.monadEffectEffect)(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(true))();
                        var v1 = Specular_FRP_Host.runHost(Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_Ref.readRef(Specular_FRP_Host.monadEffectHost)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "init";
                            }
                        })())(Data_Symbol.SProxy.value)(v)))(function (init) {
                            return Restaumatic_Form.defineForm(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost))(init({
                                parent: v,
                                key: key1,
                                subform: subform1,
                                cleanup: Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit),
                                presentWhen: presentWhen1
                            }));
                        }))();
                        var ctx = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "context";
                            }
                        })())(Data_Symbol.SProxy.value)(v))();
                        Restaumatic_Form.addContext(dictAddContext)(ctx)(subform1)();
                        return {
                            parent: v,
                            key: key1,
                            subform: subform1,
                            cleanup: v1.value1,
                            presentWhen: presentWhen1
                        };
                    };
                };
            };
        };
    };
};
var mergeMapMapping = function (dictOrd) {
    return function (dictShow) {
        return function (dictMerge) {
            return function (dictMakeEmpty) {
                return function (dictAddContext) {
                    return {
                        merge: function (m) {
                            return function (v) {
                                return function __do() {
                                    var items$prime = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "items";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v)))();
                                    Restaumatic_Form.merge(Restaumatic_Form.mergeFormField(Type_Equality.refl))(Data_Array.fromFoldable(Data_Set.foldableSet)(Data_Map.keys(m)))(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "editableKeys";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v))();
                                    var newItems = Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(m))(function (v1) {
                                        return function __do() {
                                            var v2 = (function () {
                                                var v2 = Data_Map_Internal.lookup(dictOrd)(v1.value0)(items$prime);
                                                if (v2 instanceof Data_Maybe.Just) {
                                                    return new Data_Tuple.Tuple(v2.value0, Data_Map_Internal.empty);
                                                };
                                                if (v2 instanceof Data_Maybe.Nothing) {
                                                    var item1 = makeItem(dictShow)(dictMakeEmpty)(dictAddContext)(v)(v1.value0)();
                                                    return new Data_Tuple.Tuple(item1, Data_Map_Internal.singleton(v1.value0)(item1));
                                                };
                                                throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 149, column 29 - line 154, column 53): " + [ v2.constructor.name ]);
                                            })();
                                            Restaumatic_Form.merge(dictMerge)(v1.value1)(subform(v2.value0))();
                                            return v2.value1;
                                        };
                                    })();
                                    return Control_Applicative.unless(Effect.applicativeEffect)(Data_Array["null"](newItems))(Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "items";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v)))(function (v1) {
                                        return Data_Map_Internal.union(dictOrd)(Data_Map_Internal.unions(dictOrd)(Data_Foldable.foldableArray)(newItems))(v1);
                                    }))();
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var mergeSMapMapping = function (dictOrd) {
    return function (dictShow) {
        return function (dictMerge) {
            return function (dictMakeEmpty) {
                return function (dictAddContext) {
                    return {
                        merge: function (m) {
                            return function (ff) {
                                return Restaumatic_Form.merge(mergeMapMapping(dictOrd)(dictShow)(dictMerge)(dictMakeEmpty)(dictAddContext))(Data_Newtype.unwrap()(m))(ff);
                            };
                        }
                    };
                };
            };
        };
    };
};
var makeEmpty = function (dictShow) {
    return function (dictOrd) {
        return function (dictMakeEmpty) {
            return function (dictAddContext) {
                return {
                    makeEmptyImpl: function (opts) {
                        return function __do() {
                            var items = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Map_Internal.empty)();
                            var init = Specular_Ref["new"](Effect_Class.monadEffectEffect)(function (v) {
                                return Control_Applicative.pure(Restaumatic_Form.applicativeFormDefM)(Data_Unit.unit);
                            })();
                            var editableKeys1 = Restaumatic_Form.makeEmptyImpl(Restaumatic_Form.makeEmptyFormField)({
                                name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "name";
                                    }
                                })())(Data_Symbol.SProxy.value)(opts))([ "__keys__" ])
                            })();
                            Restaumatic_Form.merge(Restaumatic_Form.mergeFormField(Type_Equality.refl))([  ])(editableKeys1)();
                            var keys1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form.queryLaxWithDefault(Restaumatic_Form.queryFormFieldI(Type_Equality.refl))(Data_Monoid.mempty(Data_Monoid.monoidArray))(editableKeys1))();
                            var context = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Vault.monoidVault))();
                            var m = {
                                name: Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "name";
                                    }
                                })())(Data_Symbol.SProxy.value)(opts),
                                items: items,
                                init: init,
                                context: context,
                                editableKeys: editableKeys1,
                                keys: keys1
                            };
                            Specular_FRP_Host.runHost(Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost)))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(keys1)))(function (ks) {
                                return function __do() {
                                    var items$prime = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Specular_Ref.value(items))();
                                    var newItems = Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray)(ks)(function (key1) {
                                        var v = Data_Map_Internal.lookup(dictOrd)(key1)(items$prime);
                                        if (v instanceof Data_Maybe.Just) {
                                            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Map_Internal.empty);
                                        };
                                        if (v instanceof Data_Maybe.Nothing) {
                                            return Data_Functor.map(Effect.functorEffect)(Data_Map_Internal.singleton(key1))(makeItem(dictShow)(dictMakeEmpty)(dictAddContext)(m)(key1));
                                        };
                                        throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 123, column 11 - line 125, column 60): " + [ v.constructor.name ]);
                                    })();
                                    return Control_Applicative.unless(Effect.applicativeEffect)(Data_Array["null"](newItems))(Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(items))(function (v) {
                                        return Data_Map_Internal.union(dictOrd)(Data_Map_Internal.unions(dictOrd)(Data_Foldable.foldableArray)(newItems))(v);
                                    }))();
                                };
                            }))();
                            return m;
                        };
                    }
                };
            };
        };
    };
};
var keys = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "keys";
            }
        })())(Data_Symbol.SProxy.value)(v1))(v));
    };
};
var keyOptions = function (v) {
    return function (v1) {
        return Restaumatic_Form.define1(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "editableKeys";
            }
        })())(Data_Symbol.SProxy.value)(v1))(Restaumatic_Form.options()(v));
    };
};
var key = function (v) {
    return v.key;
};
var itemForKey = function (dictOrd) {
    return function (v) {
        return function (k) {
            return Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
                return Data_Map_Internal.lookup(dictOrd)(k)(v1);
            })(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "items";
                }
            })())(Data_Symbol.SProxy.value)(v)));
        };
    };
};
var item = function (v) {
    return function (v1) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Restaumatic_Form.bindFormDefM)(Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "init";
            }
        })())(Data_Symbol.SProxy.value)(v1))(v)))(function () {
            return Control_Bind.bind(Restaumatic_Form.bindFormDefM)(Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Specular_Ref.readRef(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "items";
                }
            })())(Data_Symbol.SProxy.value)(v1))))(function (items) {
                return Data_Foldable.traverse_(Restaumatic_Form.applicativeFormDefM)(Data_Map_Internal.foldableMap)(v)(items);
            });
        });
    };
};
var isSelectFieldMappingItem = function (dictIsSelectField) {
    return {
        selectWriteValue: function (f) {
            return Restaumatic_Form.selectWriteValue(dictIsSelectField)(subform(f));
        },
        selectReadValue: function (f) {
            return Restaumatic_Form.selectReadValue(dictIsSelectField)(subform(f));
        },
        selectGetOptions: function (f) {
            return Restaumatic_Form.selectGetOptions(dictIsSelectField)(subform(f));
        },
        selectTouch: function (f) {
            return Restaumatic_Form.selectTouch(dictIsSelectField)(subform(f));
        }
    };
};
var hasFieldItem = function (dictHasField) {
    return {
        getField: function (label) {
            return function (v) {
                return Data_Record.getField(dictHasField)(label)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "subform";
                    }
                })())(Data_Symbol.SProxy.value)(v));
            };
        }
    };
};
var hasErrorsWithExtra = function (dictHasErrors) {
    return {
        displayedErrors: function (f) {
            return Restaumatic_Form.displayedErrors(dictHasErrors)(subform(f));
        }
    };
};
var eqItem = {
    eq: Unsafe_Reference.unsafeRefEq
};
var editableKeys = function (v) {
    return Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "editableKeys";
        }
    })())(Data_Symbol.SProxy.value)(v);
};
var dumpStateMapping = function (dictEncode) {
    return function (dictDumpState) {
        return {
            dumpState: function (v) {
                return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "items";
                    }
                })())(Data_Symbol.SProxy.value)(v)))(function (items) {
                    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "subform";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode)))))))))(Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordSingle({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })()(Specular_FRP_Base.functorDynamic)()())({
                        items: Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray)(Data_Array.fromFoldable(Data_Map_Internal.foldableMap)(items))(function (v1) {
                            return Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordCons({
                                reflectSymbol: function () {
                                    return "key";
                                }
                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                reflectSymbol: function () {
                                    return "subform";
                                }
                            })()(Specular_FRP_Base.functorDynamic)()())()())({
                                key: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "key";
                                    }
                                })())(Data_Symbol.SProxy.value)(v1)),
                                subform: Restaumatic_Form.dumpState(dictDumpState)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "subform";
                                    }
                                })())(Data_Symbol.SProxy.value)(v1))
                            });
                        })
                    }));
                });
            }
        };
    };
};
var displayedItems = function (dictOrd) {
    return function (v) {
        return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
            return function (v2) {
                return Data_Array.mapMaybe(function (k) {
                    return Data_Map_Internal.lookup(dictOrd)(k)(v1);
                })(v2);
            };
        })(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "items";
            }
        })())(Data_Symbol.SProxy.value)(v))))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "keys";
            }
        })())(Data_Symbol.SProxy.value)(v))));
    };
};
var displayWithIndex = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (l) {
                return function (renderItem) {
                    return Specular_FRP_List.dynamicListWithIndex_(dictMonadFRP)(dictMonadReplace)(displayedItems(dictOrd)(l))(function (ix) {
                        return function (ditem) {
                            return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(ditem)(renderItem(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(ix)));
                        };
                    });
                };
            };
        };
    };
};
var displayKey = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (ff) {
                return function (k) {
                    return function (display1) {
                        return Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Maybe.eqMaybe(eqItem))(itemForKey(dictOrd)(ff)(k))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(display1));
                    };
                };
            };
        };
    };
};
var display = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (l) {
                return function (renderItem) {
                    return Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Eq.eqArray(eqItem))(displayedItems(dictOrd)(l))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableArray)(renderItem));
                };
            };
        };
    };
};
var deleteItem = function (dictEq) {
    return function (v) {
        var v1 = Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "parent";
            }
        })())(Data_Symbol.SProxy.value)(v);
        return Restaumatic_Form.modifyValidValue(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "editableKeys";
            }
        })())(Data_Symbol.SProxy.value)(v1))((function () {
            var $152 = Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray));
            return function ($153) {
                return (function (a) {
                    return Data_Maybe.fromMaybe(a)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.findIndex(Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })())(Data_Symbol.SProxy.value)(v)))(a))(function (index) {
                        return Data_Array.deleteAt(index)(a);
                    }));
                })($152($153));
            };
        })());
    };
};
var deleteItemCb = function (dictEq) {
    return function (item1) {
        return deleteItem(dictEq)(item1);
    };
};
var addItem = function (dictMakeEmpty) {
    return function (dictAddContext) {
        return function (dictOrd) {
            return function (dictShow) {
                return function (field) {
                    return function (key1) {
                        return function __do() {
                            var item1 = makeItem(dictShow)(dictMakeEmpty)(dictAddContext)(field)(key1)();
                            Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "items";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Newtype.unwrap()(field))))(Data_Map_Internal.insert(dictOrd)(key1)(item1))();
                            Restaumatic_Form.modifyValidValue(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "editableKeys";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Newtype.unwrap()(field)))((function () {
                                var $154 = Data_Maybe.fromMaybe([  ]);
                                return function ($155) {
                                    return (function (v) {
                                        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ key1 ]);
                                    })($154($155));
                                };
                            })())();
                            return item1;
                        };
                    };
                };
            };
        };
    };
};
var addContextMapping = function (dictAddContext) {
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "context";
                        }
                    })())(Data_Symbol.SProxy.value)(v)))(function (v1) {
                        return Data_Semigroup.append(Data_Vault.semigroupVault)(ctx)(v1);
                    })();
                    var items = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })())(Data_Symbol.SProxy.value)(v))();
                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)(items)(function (item1) {
                        return Restaumatic_Form.addContext(dictAddContext)(ctx)(subform(item1));
                    })();
                };
            };
        }
    };
};
export {
    Mapping,
    Item,
    key,
    subform,
    item,
    presentWhen,
    keys,
    keyOptions,
    editableKeys,
    makeItem,
    itemForKey,
    displayKey,
    displayedItems,
    display,
    displayWithIndex,
    deleteItem,
    deleteItemCb,
    addItem,
    newtypeMapping,
    newtypeItem,
    hasFieldItem,
    queryItem,
    mergeItem,
    eqItem,
    isSelectFieldMappingItem,
    hasErrorsWithExtra,
    makeEmpty,
    mergeMapMapping,
    mergeSMapMapping,
    queryMapMapping,
    querySerializedMapMapping,
    addContextMapping,
    dumpStateMapping
};
//# sourceMappingURL=index.js.map
